module.exports = __webpack_public_path__ + "html/events.template.html";